import React from 'react';
import { IconButton } from '@material-tailwind/react';
import { PiPlayCircle } from 'react-icons/pi';

interface InlinePlayButtonProps {
  onClick: () => void;
  className?: string;
  iconClassName?: string;
}

const InlinePlayButton: React.FC<InlinePlayButtonProps> = ({
  onClick,
  className = '',
  iconClassName = '',
}) => {
  return (
    <IconButton
      onClick={onClick}
      variant="text"
      className={`w-8 h-8 bg-gray-50 hover:bg-gray-100 ${className}`}
    >
      <PiPlayCircle className={`h-6 w-6 ${iconClassName}`} />
    </IconButton>
  );
};

export default InlinePlayButton;
